import { render, staticRenderFns } from "./ExampleDialog.vue?vue&type=template&id=4059b707"
import script from "./ExampleDialog.vue?vue&type=script&lang=js"
export * from "./ExampleDialog.vue?vue&type=script&lang=js"
import style0 from "./ExampleDialog.vue?vue&type=style&index=0&id=4059b707&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports